export default __webpack_public_path__ + "01bd91dcc3ce34954cd6e8ed9eeb4b53.png";